import {
  createFormEventsPayload,
  type EventContext,
} from '@de/utils/createEventingPayloadsDE';
import tagularEvent from '@de/utils/tagularEvent';
import type { LeadFieldName } from './leadFieldPresets';
import type { LeadSubmitEvent } from './leadSubmitHandler';

const FIELD_NAMES: Readonly<Record<LeadFieldName, string>> = {
  firstName: 'first-name',
  lastName: 'last-name',
  email: 'email',
  phoneNumber: 'phone',
};

/**
 * `FormSubmitted` for an accepted `lead.submit`. Field values are always
 * `SANITIZED`, and no `customDimensions` are sent (the schema rejects them).
 */
export function emitLeadFormSubmitted(
  eventContext: EventContext | undefined,
  { formName, leadFields }: LeadSubmitEvent,
): void {
  if (!eventContext) return;
  const { name, payload } = createFormEventsPayload(
    {
      ...eventContext,
      ...(formName ? { formName } : {}),
      field: leadFields.map((leadField) => ({
        fieldName: FIELD_NAMES[leadField],
        fieldType: 'text',
        fieldValue: 'SANITIZED',
      })),
    },
    'FormSubmitted',
  );
  tagularEvent(name, payload);
}
